// Central config for the 4 roll strategies. Same scoring engine; different
// labels + colors so each page can render its own identity while sharing UI.

export const STRATEGIES = [
  { key: "short_call", route: "/", label: "Short Calls", short: "SC", accent: "#00E676",
    open: "Sell to Open", close: "Buy to Close", credit: "Credit",
    tagline: "Covered calls — you sold, you want to keep collecting premium" },
  { key: "long_call",  route: "/long-calls",  label: "Long Calls",  short: "LC", accent: "#5AC8FA",
    open: "Buy to Open",  close: "Sell to Close", credit: "Net Debit",
    tagline: "Long calls — bullish, roll to extend or lock gains" },
  { key: "short_put",  route: "/short-puts",  label: "Short Puts",  short: "SP", accent: "#FFD60A",
    open: "Sell to Open", close: "Buy to Close",  credit: "Credit",
    tagline: "Cash-secured puts — you sold, collecting premium below the mkt" },
  { key: "long_put",   route: "/long-puts",   label: "Long Puts",   short: "LP", accent: "#FF3B30",
    open: "Buy to Open",  close: "Sell to Close", credit: "Net Debit",
    tagline: "Long puts — bearish hedge, roll to extend or lock gains" },
];

export const STRATEGY_BY_KEY = Object.fromEntries(STRATEGIES.map((s) => [s.key, s]));
export const STRATEGY_BY_ROUTE = Object.fromEntries(STRATEGIES.map((s) => [s.route, s]));

export const strategyFromPath = (pathname) => STRATEGY_BY_ROUTE[pathname] || STRATEGIES[0];
